<mat-card class="obg-m-zhh-logout-cooldown-container">
	<div class="obg-m-zhh-logout-cooldown-header">
		<div>
			<h1>{{ 'logout-cooldown.title' | translate }}</h1>
			<p>{{ 'logout-cooldown.description' | translate }}</p>
		</div>
	</div>

	<div class="obg-m-zhh-logout-cooldown-current-amount" *ngIf="isLogoutCooldownLimitInitialized">
		<h3>{{ 'logout-cooldown.current-limit' | translate }}</h3>
		<div *ngIf="activeLogoutCooldownLimit?.cooldownInMinutes; else noLogoutCooldown">
			<label test-id="active-logout-cooldown-limit">{{ activeCooldownInHours }}</label>
		</div>

		<ng-template #noLogoutCooldown>
			<label
				*ngIf="isLimitsHistoryEmpty"
				[innerHtml]="'logout-cooldown.undefined' | translate"
				test-id="active-logout-cooldown-limit-undefined"
			></label>
			<label
				*ngIf="!isLimitsHistoryEmpty"
				[innerHtml]="'logout-cooldown.not-set' | translate"
				test-id="active-logout-cooldown-limit-none"
			></label>
		</ng-template>
	</div>

	<form [formGroup]="logoutCooldownFormGroup" test-id="editing-logout-cooldown-limit" #formDirective="ngForm">
		<div class="obg-m-zhh-logout-cooldown-form-container">
			<div class="obg-m-zhh-logout-cooldown-input-container">
				<mat-form-field floatLabel="always">
					<mat-label>{{ 'logout-cooldown.label' | translate }}</mat-label>
					<input
						matInput
						type="tel"
						[placeholder]="placeholder | translate"
						formControlName="limit"
						obgNumericNotZero
						test-id="logout-cooldown-limit-input"
					/>
				</mat-form-field>

				<obg-common-validation-renderer
					[input]="logoutCooldownFormGroup.controls.limit"
					[translationPrefix]="'logout-cooldown.daily'"
				>
				</obg-common-validation-renderer>
				<obg-input-information
					[informationMessage]="inputInformation |
					translate: { queuedLimit: queuedCooldownInHours,
					activeFrom: (queuedLogoutCooldownLimit?.startDate ? queuedLogoutCooldownLimit?.startDate : activeLogoutCooldownLimit?.endDate) | date: 'short'}"
				>
				</obg-input-information>
			</div>

			<div class="obg-m-zhh-logout-cooldown-form-buttons-container">
				<button
					mat-flat-button
					color="accent"
					[disabled]="logoutCooldownFormGroup.invalid || !isLogoutCooldownLimitInitialized || isLimitUpdateLoading"
					(click)="submitLogoutCooldown('Set')"
					test-id="set-logout-cooldown-limit"
				>
					{{ 'logout-cooldown.set' | translate }}
				</button>
				<button
					mat-flat-button
					color="primary"
					(click)="dispatchUpdate(null)"
					*ngIf="isLimitsHistoryEmpty"
					test-id="skip-logout-cooldown-limit"
				>
					{{ 'logout-cooldown.skip' | translate }}
				</button>
				<button
					mat-flat-button
					color="primary"
					*ngIf="queuedLogoutCooldownLimit || activeLogoutCooldownLimit?.endDate"
					(click)="submitLogoutCooldown('Undo')"
					test-id="undo-logout-cooldown-limit"
				>
					{{ 'logout-cooldown.undo' | translate }}
				</button>
				<button
					mat-flat-button
					color="primary"
					*ngIf="activeLogoutCooldownLimit?.cooldownInMinutes && !queuedLogoutCooldownLimit && !activeLogoutCooldownLimit?.endDate"
					[disabled]="!logoutCooldownFormGroup.pristine && logoutCooldownFormGroup.invalid"
					(click)="submitLogoutCooldown('Delete')"
					test-id="remove-logout-cooldown-limit"
				>
					{{ 'logout-cooldown.remove' | translate }}
				</button>
			</div>
		</div>
	</form>

	<p (click)="toggleInfoVisibility()" class="logout-cooldown-more-info-button">
		{{ (isInfoVisible? 'general.read-less' : 'general.read-more') | translate }}
	</p>
	<ng-container *ngIf="isInfoVisible">
		<div class="caption" [innerHtml]="'logout-cooldown.caption' | jurisdiction | translate"></div>
	</ng-container>
</mat-card>
